import { AppConfig } from '@/shared/api'
import { cn, CnInput } from '@/shared/lib/cn'

export const HomeScreenSlogan: React.FC<{
  slogan: AppConfig['config_web']['slogan']
  className?: string
}> = ({ slogan, className }) => {
  if (!slogan) return <div className="desktop:h-24" />

  const styles = {
    '--sn-tenant-slogan-font-size': slogan.fontSize,
    '--sn-tenant-slogan-line-height': slogan.lineHeight,
    '--sn-tenant-slogan-text-align': slogan.textAlign,
    '--sn-tenant-slogan-color': slogan.color,
    'fontDisplay': 'swap',
  } as React.CSSProperties

  const fontSizeCssVars: CnInput =
    'max-desktop:[--sn-font-size:22px] desktop:[--sn-font-size:var(--sn-tenant-slogan-font-size)]'

  const lineHeightCssVars: CnInput =
    'max-desktop:[--sn-line-height:26px] desktop:[--sn-line-height:var(--sn-tenant-slogan-line-height)]'

  const textAlignCssVars: CnInput = '[--sn-text-align:var(--sn-tenant-slogan-text-align)]'

  const textColorCssVars: CnInput = slogan.useDefaultColor
    ? '[--sn-color:var(--sn-color-primary-text)]'
    : '[--sn-color:var(--sn-tenant-slogan-color)]'

  const trademarkSizeVars: CnInput = 'max-desktop:[--sn-trademark-size:22px] desktop:[--sn-trademark-size:20px]'

  const cns = cn(
    fontSizeCssVars,
    lineHeightCssVars,
    textAlignCssVars,
    textColorCssVars,
    trademarkSizeVars,
    'text-balance px-5 py-6 font-semibold leading-[var(--sn-line-height)] [color:var(--sn-color)] [font-size:var(--sn-font-size)] [text-align:var(--sn-text-align)] desktop:pb-6 desktop:pt-[96px]',
    className,
  )

  return (
    <h1 className={cns} style={styles}>
      {slogan.text}
    </h1>
  )
}
